import ReportQuotationsHeader from '@/components/Reports/ReportPrivate/ReportQuotations/ReportQuotationsHeader';
import { useQuotationReportSupplierWinners } from '@/core/domain/stock/Quotations/Quotations.hooks';
import { ReportQuotationItem } from '@/core/domain/stock/Quotations/Quotations.types';
import formatterPrice from '@/utils/number/formatterPrice';
import { Button, Card, Space, Statistic, Table } from 'antd';
import { ColumnsType } from 'antd/es/table/interface';
import { Suspense, lazy } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

const TemplateReport = lazy(
  () => import('@/components/_common/TemplateReport/TemplateReport'),
);

type SearchParams = Record<'quotationId', string | undefined>;

const PrivateQuatationReportsSupplierWinners: React.FC = () => {
  const match = useRouteMatch();
  const { search } = useLocation();
  const params = Object.fromEntries(
    new URLSearchParams(search),
  ) as SearchParams;

  const { data, isLoading } = useQuotationReportSupplierWinners(
    params.quotationId ? Number(params.quotationId) : undefined,
  );

  const columns: ColumnsType<ReportQuotationItem> = [
    {
      dataIndex: 'code',
      title: 'Código',
      render: (code) => code ?? '-',
    },
    {
      dataIndex: 'description',
      title: 'Descrição',
      ellipsis: true,
    },
    {
      dataIndex: 'requestedQuantity',
      title: 'Quantidade',
      align: 'right',
      render: (value) => formatterPrice(value),
    },
    {
      dataIndex: 'suppliedQuantity',
      title: 'Qtde. fornecida',
      align: 'right',
      width: '15%',
      render: (value) => formatterPrice(value),
    },
    {
      dataIndex: 'unitPrice',
      title: 'Valor unitário($)',
      align: 'right',
      width: '15%',
      render: (value) => formatterPrice(value),
    },
    {
      title: 'Valor total($)',
      align: 'right',
      width: '15%',
      render: (_, row) =>
        formatterPrice((row.suppliedQuantity || 0) * (row.unitPrice || 0)),
    },
  ];

  return (
    <Suspense fallback={<>Carregando...</>}>
      {match.isExact && !isLoading && !!data && (
        <TemplateReport>
          <>
            <div className="btn-print">
              <Button type="primary" ghost onClick={() => window.print()}>
                Imprimir documento
              </Button>
            </div>

            <main className="reportQuotation" onLoad={() => window.print()}>
              <Space direction="vertical" className="w-100" size="large">
                <ReportQuotationsHeader
                  company={data?.result?.company}
                  title="Fornecedores Vencedores"
                />

                <Card>
                  <Statistic
                    title="Cotação"
                    value={data?.result?.quotationId}
                  />

                  {data?.result?.quotations.map((quotation, index) => (
                    <div key={index} className="m-t-20">
                      <big>
                        <strong>Fornecedor vencedor:</strong>{' '}
                        <span>{quotation.supplier.name}</span>
                      </big>
                      <Table
                        dataSource={quotation.items}
                        columns={columns}
                        pagination={false}
                        scroll={{ x: true }}
                      />
                    </div>
                  ))}
                </Card>
              </Space>
            </main>
          </>
        </TemplateReport>
      )}
    </Suspense>
  );
};

export default PrivateQuatationReportsSupplierWinners;
